/**
 * Google Analytics (GA4).
 *
 * Only runs when a measurement ID is configured. `.env.dev` sets one and
 * `.env.local` leaves it empty, so local development and previews load no tag,
 * make no requests and set no cookies: the numbers stay clean and nobody has
 * to remember to turn anything off.
 */

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

declare global {
  interface Window {
    dataLayer: IArguments[]
  }
}

/**
 * The standard gtag shim. gtag.js reads each queued entry as an `arguments`
 * object, so this pushes `arguments` rather than a plain array; the named
 * parameters are here for the type checker's benefit only.
 */
function gtag(_command: string, ..._params: unknown[]): void {
  window.dataLayer.push(arguments)
}

export function initAnalytics(): void {
  if (!MEASUREMENT_ID) return

  const tag = document.createElement('script')
  tag.async = true
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`
  document.head.appendChild(tag)

  window.dataLayer = window.dataLayer || []
  gtag('js', new Date())
  gtag('config', MEASUREMENT_ID)
}
